/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KemUserSessionWithRelations } from '../models/KemUserSessionWithRelations';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class KemUserSessionControllerService {

    /**
     * @returns KemUserSessionWithRelations KemUserSession for the given user (coach_session_state, ic_state, week, session_key), or created if none. Optionally include user details via includeRelationships.
     * @throws ApiError
     */
    public static kemUserSessionControllerFindByUserId({
        userId,
        filter,
    }: {
        userId: string,
        filter?: any,
    }): CancelablePromise<KemUserSessionWithRelations> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/kem-user-sessions/by-user/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'filter': filter,
            },
        });
    }

}
